module.exports = __webpack_public_path__ + "img/cv-template-6.d25d29a7.png";